import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useApi } from "../Providers/APIProvider";
import { KXYear } from "../Models/KXYear";
import { Portal } from "./Portal";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

import style from "./ModularCSS/TestPortals.module.css";

interface TestPortalsProps {
    SiteAdmins: Array<String> | undefined;
    SetSiteAdmins: Dispatch<SetStateAction<String[] | undefined>>;
}

export function TestPortals(props: TestPortalsProps) {
    const api = useApi();

    const debugMe = false;

    const [TAY_AcadYear, setTAY_AcadYear] = useState<string>();
    const [TAY_KXFormat, setTAY_KXFormat] = useState<string>();
    const [TAY_KXYearID, setTAY_KXYearID] = useState<number>();
    const [NAY_AcadYear, setNAY_AcadYear] = useState<string>();
    const [NAY_KXFormat, setNAY_KXFormat] = useState<string>();
    const [NAY_KXYearID, setNAY_KXYearID] = useState<number>();

    useEffect(() => {
        if (TAY_AcadYear !== undefined && TAY_KXFormat === undefined) {
            setTAY_KXFormat(TAY_AcadYear.replace("/", " - 20"));
            // from 2012/13 to Kx academic years are like this: "2012 - 2013"
        }
    }, [TAY_AcadYear]);

    useEffect(() => {
        if (NAY_AcadYear !== undefined && NAY_KXFormat === undefined) {
            setNAY_KXFormat(NAY_AcadYear.replace("/", " - 20"));
            // from 2012/13 to Kx academic years are like this: "2012 - 2013"
        }
    }, [NAY_AcadYear]);

    useEffect(() => {
        api.Accommodation.GetAcademicYears().then(data => {
            if (data !== undefined) {
                setTAY_AcadYear(data.ThisAcadYearKey);
                setNAY_AcadYear(data.NextAcadYearKey);
            }
        });
    }, []);

    useEffect(() => {
        if (TAY_KXFormat !== undefined && TAY_KXYearID === undefined) {
            api.Accommodation.GetKxAcademicYearID(TAY_KXFormat).then(data => { setTAY_KXYearID(data) });
        }
        // from 2012/13 to Kx academic years are like this: "2012 - 2013"
    }, [TAY_KXFormat]);

    useEffect(() => {
        if (NAY_KXFormat !== undefined && NAY_KXYearID === undefined) {
            api.Accommodation.GetKxAcademicYearID(NAY_KXFormat).then(data => { setNAY_KXYearID(data) });
        }
        // from 2012/13 to Kx academic years are like this: "2012 - 2013"
    }, [NAY_KXFormat]);

    if (TAY_AcadYear !== undefined && TAY_KXFormat !== undefined && TAY_KXYearID !== undefined &&
        NAY_AcadYear !== undefined && NAY_KXFormat !== undefined && NAY_KXYearID !== undefined) {

        let TAY: KXYear = {
            AcadYear: TAY_AcadYear,
            KXFormat: TAY_KXFormat,
            KXID: TAY_KXYearID
        };

        let NAY: KXYear = {
            AcadYear: NAY_AcadYear,
            KXFormat: NAY_KXFormat,
            KXID: NAY_KXYearID
        };
        // this returns test students for dev purposes
        return <Tabs className={style.TestTabs}>
            <TabList className={style.TestTabList}>
                <Tab className={style.TestTab}>John Isemimen</Tab>
                <Tab className={style.TestTab}>Emma Praud</Tab>
                <Tab className={style.TestTab}>Lucy Bodman</Tab>
                <Tab className={style.TestTab}>Jessica Clews</Tab>
                <Tab className={style.TestTab}>Madieson Blakesley</Tab>
                <Tab className={style.TestTab}>Simeon Tsenov</Tab>
                <Tab className={style.TestTab}>Abbas Ali</Tab>
                <Tab className={style.TestTab}>Thomas Sabhat</Tab>
                <Tab className={style.TestTab}>Daniyal Hummel</Tab>
                <Tab className={style.TestTab}>Muhammed Abbas</Tab>
                <Tab className={style.TestTab}>Christina Karaoli</Tab>
                <Tab className={style.TestTab}>Benedetta Talotta</Tab>
                <Tab className={style.TestTab}>Jack Roper</Tab>
            </TabList>
            <TabPanel className={style.TestTabPanel}>
                <blockquote>Mr John David Chiduzor Isemimen (ji22096), Col UG UK, eligible, no applications, can apply for 24/25 waiting list, can apply for 25/26 accomm.</blockquote>
                <Portal Ident='ji22096' ThisAcademicYear={TAY} NextAcademicYear={NAY} Debug={debugMe}
                    SiteAdmins={props.SiteAdmins} SetSiteAdmins={props.SetSiteAdmins} />
            </TabPanel>
            <TabPanel className={style.TestTabPanel}>
                <blockquote>Miss Emma Claudine Annabelle Praud (ep23843), Col UG Overseas, eligible, no applications, can apply for 25/26 Oct only.</blockquote>
                <Portal Ident='ep23843' ThisAcademicYear={TAY} NextAcademicYear={NAY} Debug={debugMe}
                    SiteAdmins={props.SiteAdmins} SetSiteAdmins={props.SetSiteAdmins} />
            </TabPanel>
            <TabPanel className={style.TestTabPanel}>
                <blockquote>Miss Lucy Katherine Bodman (lb23103), Col UG UK, eligible, accepted application for 24/25, can apply for 25/26.</blockquote>
                <Portal Ident='lb23103' ThisAcademicYear={TAY} NextAcademicYear={NAY} Debug={debugMe}
                    SiteAdmins={props.SiteAdmins} SetSiteAdmins={props.SetSiteAdmins} />
            </TabPanel>
            <TabPanel className={style.TestTabPanel}>
                <blockquote>Miss Jessica Rose Clews (jc23939), So UG UK, eligible, no applications, can apply for 25/26 Oct only.</blockquote>
                <Portal Ident='jc23939' ThisAcademicYear={TAY} NextAcademicYear={NAY} Debug={debugMe}
                    SiteAdmins={props.SiteAdmins} SetSiteAdmins={props.SetSiteAdmins} />
            </TabPanel>
            <TabPanel className={style.TestTabPanel}>
                <blockquote>Miss Madieson Ocean Blakesley (mb23920), Col UG UK, eligible, pending offer for 24/25, can apply for 25/26.</blockquote>
                <Portal Ident='mb23920' ThisAcademicYear={TAY} NextAcademicYear={NAY} Debug={debugMe}
                    SiteAdmins={props.SiteAdmins} SetSiteAdmins={props.SetSiteAdmins} />
            </TabPanel>
            <TabPanel className={style.TestTabPanel}>
                <blockquote>Mr Simeon Vladimirov Tsenov (st23615), Col UG UK, eligible, pending offer for 24/25, can apply for 25/26.</blockquote>
                <Portal Ident='st23615' ThisAcademicYear={TAY} NextAcademicYear={NAY} Debug={debugMe}
                    SiteAdmins={props.SiteAdmins} SetSiteAdmins={props.SetSiteAdmins} />
            </TabPanel>
            <TabPanel className={style.TestTabPanel}>
                <blockquote>Mr Abbas Mahin Ali (aa22081), Col UG UK, eligible, no applications, can apply for both.</blockquote>
                <Portal Ident='aa22081' ThisAcademicYear={TAY} NextAcademicYear={NAY} Debug={debugMe}
                    SiteAdmins={props.SiteAdmins} SetSiteAdmins={props.SetSiteAdmins} />
            </TabPanel>
            <TabPanel className={style.TestTabPanel}>
                <blockquote>Mr Thomas Sabhat (ts22718), Col UG UK, eligible, no applications, can apply for both.</blockquote>
                <Portal Ident='ts22718' ThisAcademicYear={TAY} NextAcademicYear={NAY} Debug={debugMe}
                    SiteAdmins={props.SiteAdmins} SetSiteAdmins={props.SetSiteAdmins} />
            </TabPanel>
            <TabPanel className={style.TestTabPanel}>
                <blockquote>Mr Daniyal Hummel (dh22098), Col UG UK, eligible, no applications, can apply for both.</blockquote>
                <Portal Ident='dh22098' ThisAcademicYear={TAY} NextAcademicYear={NAY} Debug={debugMe}
                    SiteAdmins={props.SiteAdmins} SetSiteAdmins={props.SetSiteAdmins} />
            </TabPanel>
            <TabPanel className={style.TestTabPanel}>
                <blockquote>Mr Muhammed Mustafa Abbas (ma23186), Col UG UK, eligible, accepted application for 24/25, can apply for 25/26.</blockquote>
                <Portal Ident='ma23186' ThisAcademicYear={TAY} NextAcademicYear={NAY} Debug={debugMe}
                    SiteAdmins={props.SiteAdmins} SetSiteAdmins={props.SetSiteAdmins} />
            </TabPanel>
            <TabPanel className={style.TestTabPanel}>
                <blockquote>Miss Christina Karaoli (ck23088), Col UG Overseas, eligible, no applications, can apply for 25/26 Oct only.</blockquote>
                <Portal Ident='ck23088' ThisAcademicYear={TAY} NextAcademicYear={NAY} Debug={debugMe}
                    SiteAdmins={props.SiteAdmins} SetSiteAdmins={props.SetSiteAdmins} />
            </TabPanel>
            <TabPanel className={style.TestTabPanel}>
                <blockquote>Miss Benedetta Talotta (bt23231), So UG Overseas, eligible, no applications, can apply for 25/26 Oct only.</blockquote>
                <Portal Ident='bt23231' ThisAcademicYear={TAY} NextAcademicYear={NAY} Debug={debugMe}
                    SiteAdmins={props.SiteAdmins} SetSiteAdmins={props.SetSiteAdmins} />
            </TabPanel>
            <TabPanel className={style.TestTabPanel}>
                <blockquote>Mr Jack Roper (jr23219), Col UG UK, eligible, no applications, can apply for both.</blockquote>
                <Portal Ident='jr23219' ThisAcademicYear={TAY} NextAcademicYear={NAY} Debug={debugMe}
                    SiteAdmins={props.SiteAdmins} SetSiteAdmins={props.SetSiteAdmins} />
            </TabPanel>
        </Tabs>;
    } else {
        return <></>;
    }
}